import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { c2cApi } from "../../api/c2c-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function ChatCenter() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  return (
    <div className="min-h-screen bg-neutral-900 w-full">
      <AcendexLayout
        theme="light"
        mobileTopBarTitle={translate(getText("在線客服"))}
        pcTopBarTitle={translate(getText("在線客服"))}
        hideBottomBar
      >
        <div className="container mx-auto">
        {/* Main content area */}
          <CenterPage />
      </div>
      </AcendexLayout>
    </div>
  );
}
